"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDocumentTypeLabel = exports.configureCard = exports.shouldDisplayRefusedDirectDebitMessage = exports.getPDFLinksAndDetails = exports.hasItemWithDirectDebitOngoing = exports.isRefusedDirectDebit = exports.areAllOpenTransactionsOngoing = exports.hasAnyOngoingPaymentTransaction = exports.hasItemOngoing = exports.filterImportantUnassignedFinancialTransactions = exports.getTransactionRefs = exports.areTransactionsInRefusedDirectDebit = exports.hasAnyOverdueTransactionWithOngoingDd = exports.isTransactionInOngoingDirectDebit = exports.hasAtLeastOneOngoingDocument = void 0;
var entities_1 = require("../models/entities");
var payment_1 = require("../models/payment");
var promiseOfPaymentService_1 = require("./promiseOfPaymentService");
var lodash_clonedeep_1 = __importDefault(require("lodash.clonedeep"));
var hasAtLeastOneOngoingDocument = function (documents) {
    return documents.some(function (document) {
        return document.paymentStatus === entities_1.PaymentStatus.ONGOING_PAYMENT ||
            isTransactionInOngoingDirectDebit(document);
    });
};
exports.hasAtLeastOneOngoingDocument = hasAtLeastOneOngoingDocument;
function isTransactionInOngoingDirectDebit(document) {
    var _a;
    return ((_a = document.paymentInfo) === null || _a === void 0 ? void 0 : _a.directDebitInfo) === entities_1.DirectDebitInfo.ONGOING;
}
exports.isTransactionInOngoingDirectDebit = isTransactionInOngoingDirectDebit;
function hasAnyOverdueTransactionWithOngoingDd(billingTransaction) {
    var _a, _b;
    return ((_b = (_a = billingTransaction.result) === null || _a === void 0 ? void 0 : _a.openTransactions.billingDocuments.some(function (document) {
        return document.paymentStatus === entities_1.PaymentStatus.OVERDUE &&
            isTransactionInOngoingDirectDebit(document);
    })) !== null && _b !== void 0 ? _b : false);
}
exports.hasAnyOverdueTransactionWithOngoingDd = hasAnyOverdueTransactionWithOngoingDd;
function areTransactionsInRefusedDirectDebit(openTransactions) {
    var softRefused = false;
    var hardRefused = false;
    openTransactions === null || openTransactions === void 0 ? void 0 : openTransactions.forEach(function (document) {
        var _a, _b;
        if (((_a = document.paymentInfo) === null || _a === void 0 ? void 0 : _a.directDebitInfo) === entities_1.DirectDebitInfo.HARDREFUSED) {
            hardRefused = true;
        }
        if (((_b = document.paymentInfo) === null || _b === void 0 ? void 0 : _b.directDebitInfo) === entities_1.DirectDebitInfo.SOFTREFUSED) {
            softRefused = true;
        }
    });
    return { softRefused: softRefused && !hardRefused, hardRefused: hardRefused };
}
exports.areTransactionsInRefusedDirectDebit = areTransactionsInRefusedDirectDebit;
var getTransactionRefs = function (openTransactions, payButtonLevel, openTransactionToPay) {
    var references = [];
    if (payButtonLevel === payment_1.PayButtonLevel.transaction) {
        if (openTransactionToPay !== undefined) {
            references.push(openTransactionToPay.reference);
        }
    }
    else {
        openTransactions.forEach(function (openTransaction) {
            if (shouldIncludeReference(openTransaction, payButtonLevel)) {
                references.push(openTransaction.reference);
            }
        });
    }
    return references;
};
exports.getTransactionRefs = getTransactionRefs;
var shouldIncludeReference = function (billingDocument, paymentLevel) {
    if (paymentLevel === payment_1.PayButtonLevel.balancePOP) {
        return billingDocument.paymentStatus === entities_1.PaymentStatus.OVERDUE;
    }
    return true;
};
function filterImportantUnassignedFinancialTransactions(billingTransaction) {
    var clonedBillingTransaction = (0, lodash_clonedeep_1.default)(billingTransaction);
    clonedBillingTransaction.openTransactions.unassignedFinancialTransactions =
        clonedBillingTransaction.openTransactions.unassignedFinancialTransactions.filter(function (unassignedFinancialTransaction) {
            return unassignedFinancialTransaction.type === 'PAYMENT' &&
                Number(unassignedFinancialTransaction.amount) !== 0;
        });
    return clonedBillingTransaction;
}
exports.filterImportantUnassignedFinancialTransactions = filterImportantUnassignedFinancialTransactions;
function hasAtLeastOneDocumentWithPaymentStatus(billingTransaction, status) {
    var _a, _b;
    return ((_b = (_a = billingTransaction.result) === null || _a === void 0 ? void 0 : _a.openTransactions.billingDocuments.some(function (document) { return document.paymentStatus === status; })) !== null && _b !== void 0 ? _b : false);
}
// TODO: not unit-tested
function hasItemOngoing(billingTransaction) {
    return hasAtLeastOneDocumentWithPaymentStatus(billingTransaction, entities_1.PaymentStatus.ONGOING_PAYMENT);
}
exports.hasItemOngoing = hasItemOngoing;
function hasAnyOngoingPaymentTransaction(billingTransaction) {
    return hasItemOngoing(billingTransaction) || hasItemWithDirectDebitOngoing(billingTransaction);
}
exports.hasAnyOngoingPaymentTransaction = hasAnyOngoingPaymentTransaction;
function areAllOpenTransactionsOngoing(billingTransactions) {
    var openTransactions = billingTransactions === null || billingTransactions === void 0 ? void 0 : billingTransactions.openTransactions.billingDocuments;
    return (openTransactions !== undefined &&
        openTransactions.length > 0 &&
        openTransactions.every(function (document) {
            var _a;
            return document.paymentStatus === entities_1.PaymentStatus.ONGOING_PAYMENT ||
                ((_a = document.paymentInfo) === null || _a === void 0 ? void 0 : _a.directDebitInfo) === entities_1.DirectDebitInfo.ONGOING;
        }));
}
exports.areAllOpenTransactionsOngoing = areAllOpenTransactionsOngoing;
/**
 * This return true if one of the open transactions is in Hard Refused or Soft Refused,
 * @param billingTransaction The IEMData corresponding to the billingTransaction
 */
function isRefusedDirectDebit(billingTransaction) {
    var _a;
    var openTransactions = (_a = billingTransaction.result) === null || _a === void 0 ? void 0 : _a.openTransactions.billingDocuments;
    if (openTransactions !== undefined) {
        var _b = areTransactionsInRefusedDirectDebit(openTransactions), softRefused = _b.softRefused, hardRefused = _b.hardRefused;
        return softRefused || hardRefused;
    }
    return false;
}
exports.isRefusedDirectDebit = isRefusedDirectDebit;
function hasItemWithDirectDebitOngoing(billingTransaction) {
    var _a, _b;
    return ((_b = (_a = billingTransaction.result) === null || _a === void 0 ? void 0 : _a.openTransactions.billingDocuments.some(function (document) { var _a; return ((_a = document.paymentInfo) === null || _a === void 0 ? void 0 : _a.directDebitInfo) === entities_1.DirectDebitInfo.ONGOING; })) !== null && _b !== void 0 ? _b : false);
}
exports.hasItemWithDirectDebitOngoing = hasItemWithDirectDebitOngoing;
function getPDFLinksAndDetails(document) {
    var _a;
    var documentType = (_a = document === null || document === void 0 ? void 0 : document.type) !== null && _a !== void 0 ? _a : '';
    switch (documentType) {
        case 'TELCO':
        case 'DN':
        case 'MC':
        case 'CN':
        case 'RET_TP':
        case 'NI2P':
            return { showPDFLink: true, showDetails: false };
        case 'REFUND':
        case 'AP':
        case 'PAYMENT':
        case 'CORR_CN':
        case 'CORR_DN':
        case 'IP':
            return { showPDFLink: false, showDetails: false };
        case 'BILL_TP':
        case 'BILL':
        case 'I2P':
        case 'I2P_TP':
            return { showPDFLink: true, showDetails: true };
        default:
            return { showPDFLink: false, showDetails: false };
    }
}
exports.getPDFLinksAndDetails = getPDFLinksAndDetails;
/**
 * Indicate if the refused direct debit message should be displayed
 * It should be if there is an overdue balance, or the transactions are in refused direct debit
 * @param billingTransaction
 * @param pop
 */
function shouldDisplayRefusedDirectDebitMessage(billingTransaction, pop, language) {
    var _a;
    var openTransactions = (_a = billingTransaction.result) === null || _a === void 0 ? void 0 : _a.openTransactions.billingDocuments;
    var _b = areTransactionsInRefusedDirectDebit(openTransactions), softRefused = _b.softRefused, hardRefused = _b.hardRefused;
    return (softRefused || hardRefused) && !(0, promiseOfPaymentService_1.hasPopMessage)(pop, language);
}
exports.shouldDisplayRefusedDirectDebitMessage = shouldDisplayRefusedDirectDebitMessage;
function configureCard(document, translate) {
    var _a, _b;
    var Months = [
        translate('bills.months.january'),
        translate('bills.months.february'),
        translate('bills.months.march'),
        translate('bills.months.april'),
        translate('bills.months.may'),
        translate('bills.months.june'),
        translate('bills.months.july'),
        translate('bills.months.august'),
        translate('bills.months.september'),
        translate('bills.months.october'),
        translate('bills.months.november'),
        translate('bills.months.december'),
    ];
    var date = document.documentDate ? document.documentDate.split('/') : '';
    var title = "".concat(Months[Number(date[1]) - 1], " ").concat(date[2]);
    var subtitle = "".concat((_a = getDocumentTypeLabel(translate, document.type)) !== null && _a !== void 0 ? _a : '', " : ").concat(document.reference);
    var newBill = document.paymentStatus === entities_1.PaymentStatus.OPEN &&
        ((_b = document.paymentInfo) === null || _b === void 0 ? void 0 : _b.directDebitInfo) !== entities_1.DirectDebitInfo.ONGOING;
    return { newBill: newBill, title: title, subtitle: subtitle };
}
exports.configureCard = configureCard;
function getDocumentTypeLabel(translate, documentType) {
    var DocumentTypeLabelTranslationKeys = new Map([
        ['TELCO', 'bills.billTypes.telco'],
        ['DN', 'bills.billTypes.dn'],
        ['MC', 'bills.billTypes.mc'],
        ['BILL_TP', 'bills.billTypes.billTp'],
        ['BILL', 'bills.billTypes.bill'],
        ['REFUND', 'bills.billTypes.refund'],
        ['CN', 'bills.billTypes.cn'],
        ['AP', 'bills.billTypes.ap'],
        ['PAYMENT', 'bills.billTypes.payment'],
        ['RET_TP', 'bills.billTypes.retTp'],
        ['I2P', 'bills.billTypes.i2p'],
        ['I2P_TP', 'bills.billTypes.i2pTp'],
        ['NI2P', 'bills.billTypes.ni2p'],
        ['CORR_CN', 'bills.billTypes.corrCn'],
        ['CORR_DN', 'bills.billTypes.corrDn'],
        ['IP', 'bills.billTypes.ip'], // Not used anymore
    ]);
    var documentTypeLabelTranslationKey = DocumentTypeLabelTranslationKeys.get(documentType);
    return documentTypeLabelTranslationKey ? translate(documentTypeLabelTranslationKey) : undefined;
}
exports.getDocumentTypeLabel = getDocumentTypeLabel;
